/* src/app/forms/acess-view/menu-view/menu-view.component.scss */
.section-toolbar {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.section-hint {
  color: var(--tem-muted);
  font-size: var(--tem-fs-sm);
}
.filter-field {
  max-width: 260px;
}
.clear-icon {
  color: var(--tem-muted);
  cursor: pointer;
}
.clear-icon:hover {
  color: var(--tem-ink);
}
.grid-box {
  border: 1px solid var(--tem-border);
  border-radius: var(--tem-radius);
  overflow: hidden;
  background: var(--tem-surface);
}
.grid-row {
  display: grid;
  align-items: center;
  min-height: 34px;
  padding: 0 12px;
  gap: 8px;
  color: var(--tem-ink);
  border-bottom: 1px solid var(--tem-border);
  cursor: pointer;
}
.grid-row:hover:not(.grid-header) {
  background: var(--tem-accent-soft);
}
.grid-header {
  background: var(--tem-surface-2);
  color: var(--tem-muted);
  font-size: var(--tem-fs-sm);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  cursor: default;
}
.row-selected {
  background: var(--tem-accent-soft);
}
.rows-scroll {
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}
.col-check {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0;
  line-height: 1.2;
}
.col-check label {
  margin: 0;
}
.cell-ellipsis {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  min-width: 0;
}
:host {
  display: flex;
  flex-direction: column;
}
.menu-acess {
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-family: var(--tem-font-family);
}
.tree-node-row {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  gap: 4px;
  padding: 0 4px;
}
.node-icon {
  color: var(--tem-deep);
  font-size: 16px;
}
.node-label {
  color: var(--tem-ink);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.node-toggle {
  display: inline-flex;
  flex-grow: 1;
  justify-content: flex-end;
  padding-right: 8px;
}
/*# sourceMappingURL=menu-view.component.css.map */
